/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_Split_Min_HintInputs */

const vi_lot_items_split_min_hint = /** @type {(inputs: Lot_Items_Split_Min_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cần ít nhất 2 lô con`)
};

/**

* @param {Lot_Items_Split_Min_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_split_min_hint = /** @type {((inputs?: Lot_Items_Split_Min_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Split_Min_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_split_min_hint(inputs)
});